import { z } from 'zod';
import { PriceSchema } from '~entities/price/model/price.contracts';

export const OfferSchema = z.object({
  type: z.enum(['ROOM', 'LAST_MINUTE_PACKAGE', 'PACKAGE']).optional(),
  arrivalDay: z.string(),
  departureDay: z
    .object({
      date: z.string(),
      arrivalRestricted: z.boolean(),
      departureRestricted: z.boolean(),
      dayRestricted: z.boolean(),
    })
    .optional(),
  nights: z.number().int(),
  adults: z.number().int().optional(),
  children: z.array(z.number().int()).optional(),
  price: PriceSchema.optional(),
  minimumPrice: PriceSchema.optional(),
  overlayMessages: z.array(z.string()).optional(),
  // Only an explicit false means "a price policy allows an inquiry but not a booking". Undefined
  // is a backend that predates samera/samera#3217, which must keep both CTAs.
  bookable: z.boolean().optional(),

  rateId: z.number().int().optional(),
  roomId: z.number().int().optional(),
  lastMinutePackageId: z.number().int().optional(),
  packageId: z.number().int().optional(),
  packageCategoryId: z.number().int().optional(),
});

export const OffersQueryDtoSchema = z.object({
  adults: z.number().min(1),
  children: z.array(z.number()),
  arrivalDay: z.string().optional(),
  nights: z.number().min(1).optional(),
  oneIdentifier: z.string(),
});
